interface GrantsIconProps {
  className?: string;
}

export function GrantsIcon({ className }: GrantsIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      {/* Portico triangle roof */}
      <polyline points="4 10 12 4 20 10" />
      {/* Left column */}
      <line x1="7" y1="10" x2="7" y2="18" />
      {/* Right column */}
      <line x1="17" y1="10" x2="17" y2="18" />
      {/* Base/floor */}
      <line x1="3" y1="18" x2="21" y2="18" />
      {/* Dollar sign between columns */}
      <path d="M12 11v6" />
      <path d="M10.5 12.2c0 0 0.6-0.5 1.5-0.5s1.5 0.4 1.5 1c0 0.6-0.6 0.9-1.5 1.1s-1.5 0.5-1.5 1c0 0.6 0.6 1 1.5 1s1.5-0.5 1.5-0.5" />
    </svg>
  );
}
